import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, publishLast, refCount, take } from 'rxjs';
import { DeferredConfigModel } from '../../models/start-up-config/deferred-config';
import { UrlConfigModel } from '../../models/start-up-config/initial-config.model';
import { SessionInfoModel } from '../../models/start-up-config/session-info-model';
import { StartUpConfigService } from '../data/start-up-config.service';

@Injectable({
  providedIn: 'root'
})
export class StartUpConfigUiService {
  constructor(private startupConfig: StartUpConfigService) {}

  public loadConsentScript$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public sessionInfo$: Observable<SessionInfoModel> = this.startupConfig.getSessionConfig().pipe(take(1), publishLast(), refCount());

  public initialConfig$: Observable<UrlConfigModel> = this.startupConfig.getInitialConfig().pipe(take(1), publishLast(), refCount());

  public deferredConfig$: Observable<DeferredConfigModel> = this.startupConfig.getDeferredConfig().pipe(take(1), publishLast(), refCount());

  public cmsUrl$: Observable<string | undefined> = this.initialConfig$.pipe(map((initialConfig: any) => initialConfig.cmsUrl ?? ''));

  private sessionExpiryTriggeredFor: string[] = [];

  public sessionTrackingId$: Observable<string | null> = this.sessionInfo$.pipe(map((sessionInfo: any) => (sessionInfo != null ? sessionInfo.sessionTrackingId : null)));

  public sessionExpiryPollingFrequency$: Observable<number | null> = this.sessionInfo$.pipe(map((sessionInfo: any) => (sessionInfo != null ? sessionInfo.sessionExpiryPollingFrequency : null)));

  public hasSessionExpiryTriggeredFor(sessionTrackingId: string): boolean {
    return (
      this.sessionExpiryTriggeredFor.filter(function (x) {
        return x === sessionTrackingId;
      }).length > 0
    );
  }

  public addSessionExpiryTrigger(sessionTrackingId: string) {
    this.sessionExpiryTriggeredFor.push(sessionTrackingId);
  }

  public getPreloaderImageUrl(): Observable<string> {
    return this.initialConfig$.pipe(map((x: any) => x.baseImageUrl + 'shared/waitimage.gif'));
  }

  public redirectToCms(): void {
    this.cmsUrl$.pipe(take(1)).subscribe({
      next: (cmsUrl: any) => {
        if (cmsUrl) {
          location.href = cmsUrl;
        }
      }
    });
  }
}
